module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/world-internet-c3dff5d23d9b32aec7986576c6a0cf91.jpg";